import {
  billingDiscountsQuery,
  billingFreeLimitsQuery,
  billingSubscriptionQuery,
} from '@blesk-frontend/api';
import {useQuery} from '@tanstack/react-query';

export const useTeamSubscription = () => {
  const {
    data: discounts,
    isLoading: isDiscountsLoading,
    refetch: refetchDiscounts,
  } = useQuery(billingDiscountsQuery);

  const {
    data: subscription,
    isLoading: isSubscriptionLoading,
    refetch: refetchSubscription,
  } = useQuery(billingSubscriptionQuery);

  const {
    data: freeLimits,
    isLoading: isFreeLimitsLoading,
    refetch: refetchFreeLimits,
  } = useQuery(billingFreeLimitsQuery);

  const isLoading = isDiscountsLoading || isSubscriptionLoading || isFreeLimitsLoading;

  const isAllowCreateGuide = !isLoading
    ? !subscription
      ? (freeLimits?.current || 0) < (freeLimits?.limit || 0)
      : true
    : false;

  return {
    discounts,
    subscription,
    freeLimits,
    isLoading,
    refetchDiscounts,
    isAllowCreateGuide,
    refetchSubscription,
    refetchFreeLimits,
  };
};
